export default {
    loadingDefault: 'Laster...',
    loadingPage: 'Laster siden...',
    loadingDebitCards: 'Henter bankkort...',
    loadingCreditCards: 'Henter kredittkort...',
    loadingCardsOnSharedAccounts: 'Henter delte kort...',
    loadingBillingAccount: 'Henter kontoinformasjon...',
    loadingFetchUser: 'Henter kontaktinfo...',
    loadingUpdateUser: 'Oppdaterer kontaktinfo...',
    loadingUpdateSpendingLimit: 'Oppdaterer beløpsgrense...',
    loadingReduction: 'Utfører kredittendring...',
    loadingRegion: 'Henter regionsperre...',
    loadingTransactions: 'Henter bevegelser...',
    loadingPin: 'Henter PIN-kode...',
    loadingTransferExecute: 'Utfører overføring...',
    loadingTransfers: 'Henter overføringer...',
    loadingBlock: 'Gjennomfører kortsperre...',
    loadingBlockOpen: 'Gjenåpner kort...',
    loadingReordering: 'Bestiller kort...',
    loadingYearStatement: 'Henter årsoppgaver...',
    loadingPDF: 'Laster PDF...',
    loadingTransactionDetails: 'Henter transaksjonsdetaljer...',
    loadingMoreTransactions: 'Henter flere transaksjoner...',
    loadingVirtualCard: 'Henter kort...',
    loadingBlockCard: 'Sperrer kortet...',
    loadingHardBlockingCard: 'Sperrer kortet permanent...',
    loadingReorderCard: 'Bestiller nytt kort...',
    loadingConversionRate: 'Henter kurs...',
    loadingDigitalCard: 'Henter digitalt kort...',
    loadingPIN: 'Henter PIN-kode...',
    loadingGTPWalletSigning: 'Går til signering...',
};
